<template>
  <button class="btn btn-sm btn-outline-gray mr-1 mb-1" :disabled="busy" @click="refollow">
    <b-spinner v-if="busy" small variant="primary"></b-spinner>
    <i v-if="!busy" class="fa fa-undo"></i>
    Theo dõi lại
  </button>
</template>

<script>
export default {
  props: {
    benhNhan: {
      type: Object,
    },
  },
  data() {
    return {
      busy: false,
    };
  },
  methods: {
    async refollow() {
      try {
        this.busy = true;
        const response = await this.$service.post(`/benh-nhan/refollow/${this.benhNhan._id}`);
        if (!response.data) throw new Error('Thất bại');
        this.$swal({
          title: this.$t('success'),
          text: 'Theo dõi lại bệnh nhân thành công',
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } catch (error) {
        this.$swal({
          title: this.$t('error'),
          text: 'Theo dõi lại bệnh nhân thất bại',
          icon: 'error',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      } finally {
        this.busy = false;
        this.$bus.$emit('reloadBenhNhanList');
      }
    },
  },
};
</script>
